import React from 'react';

const ContactUs: React.FC = () => {
    return (
        <article className='aboutus'>
            <h1>聯絡我們
            </h1>
            <p>如果您有任何問題，請聯繫我們。
            </p>
            <ul >
                <li>1 TEL：02-27780958</li>
                <li>2 WebSite：edisoft.com.tw</li>
            </ul>
        </article>
    );
};

export default ContactUs;